

















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class ExternalLinkIcon extends Vue {
  @Prop({ default: '10' }) readonly width?: string;
  @Prop({ default: '11' }) readonly height?: string;
  @Prop({ default: 'currentColor' }) readonly fill?: string;
}
